import React from "react";
import { Box, Text, SimpleGrid, Image } from "@chakra-ui/react";
import { ChapterHeading, Reveal, MotionBox, glass } from "./story";

import html from "../Assets/html.png";
import bootstrap from "../Assets/bootstrap.png";
import chakra from "../Assets/chakra.png";
import css from "../Assets/css.png";
import express from "../Assets/express.png";
import git from "../Assets/git.png";
import javascript from "../Assets/javascript.png";
import material from "../Assets/material.png";
import mongodb from "../Assets/mongodb.png";
import node from "../Assets/node.png";
import npm from "../Assets/npm.png";
import postman from "../Assets/postman.png";
import react from "../Assets/react.png";
import redux from "../Assets/redux.png";
import tailwind from "../Assets/tailwind.png";
import next from "../Assets/next.png";
import pngegg from "../Assets/pngegg.png";

const skillsData = [
  { name: "HTML", imageSrc: html },
  { name: "CSS", imageSrc: css },
  { name: "JavaScript", imageSrc: javascript },
  { name: "React", imageSrc: react },
  { name: "Next.js", imageSrc: next },
  { name: "Node.js", imageSrc: node },
  { name: "Express.js", imageSrc: express },
  { name: "MongoDB", imageSrc: mongodb },
  { name: "PostgreSQL", imageSrc: pngegg },
  { name: "Redux", imageSrc: redux },
  { name: "Chakra UI", imageSrc: chakra },
  { name: "Tailwind", imageSrc: tailwind },
  { name: "Bootstrap", imageSrc: bootstrap },
  { name: "Material UI", imageSrc: material },
  { name: "Git", imageSrc: git },
  { name: "npm", imageSrc: npm },
  { name: "Postman", imageSrc: postman },
];

export default function Skills() {
  return (
    <Box id="Skill's" py={{ base: "80px", md: "120px" }} px={{ base: "6%", md: "9%" }}>
      <ChapterHeading
        chapter="Chapter 04 · The Arsenal"
        title="The tools I reach for"
        subtitle="The stack I've earned through shipping, from the interface all the way down to the database."
      />

      <SimpleGrid
        maxW="1000px"
        mx="auto"
        columns={{ base: 3, sm: 4, md: 6 }}
        spacing={{ base: "12px", md: "18px" }}
      >
        {skillsData.map((skill, index) => (
          <Reveal key={skill.name} delay={(index % 6) * 0.05}>
            <MotionBox
              whileHover={{ y: -6, scale: 1.05 }}
              transition={{ type: "spring", stiffness: 300 }}
              {...glass({ p: { base: "14px", md: "18px" } })}
              textAlign="center"
              _hover={{
                borderColor: "#60A5FA",
                boxShadow: "0 0 22px rgba(96,165,250,0.35)",
              }}
            >
              <Image
                src={skill.imageSrc}
                alt={skill.name}
                h={{ base: "40px", md: "52px" }}
                w={{ base: "40px", md: "52px" }}
                objectFit="contain"
                mx="auto"
              />
              <Text fontSize={{ base: "11px", md: "sm" }} mt="10px" color="#c2c9d6">
                {skill.name}
              </Text>
            </MotionBox>
          </Reveal>
        ))}
      </SimpleGrid>
    </Box>
  );
}
